import { ObjectLike } from '@/types/objectlike.types';

export default function (loginTexts: ObjectLike, formRules: ObjectLike) {
  const {
    required,
  } = formRules;

  const {
    usernameLabel,
    passwordLabel,
  } = loginTexts;

  const usernameRules = [
    ...required(usernameLabel),
  ];

  const passwordRules = [
    ...required(passwordLabel),
  ];

  return {
    usernameRules,
    passwordRules,
  };
}
